@let canSelectPanoramax = immersiveViewService.canSelectImmersiveView(ImmersiveViewServiceEnum.PANORAMAX);
@let canSelectGoogleStreetView =
    immersiveViewService.canSelectImmersiveView(ImmersiveViewServiceEnum.GOOGLE_STREET_VIEW);

<div class="immersive-view-selection flex items-center gap-2">
    <app-button
        [disabled]="!canSelectPanoramax"
        [label]="'immersiveView.panoramax' | transloco"
        [tooltip]="canSelectPanoramax ? undefined : ('immersiveView.panoramaxUnavailable' | transloco)"
        [type]="
            immersiveViewService.currentImmersiveView() === ImmersiveViewServiceEnum.PANORAMAX
                ? ButtonType.PRIMARY
                : ButtonType.SECONDARY
        "
        (onClick)="selectView(ImmersiveViewServiceEnum.PANORAMAX)" />

    <app-button
        [disabled]="!canSelectGoogleStreetView"
        [label]="'immersiveView.googleStreetView' | transloco"
        [tooltip]="canSelectGoogleStreetView ? undefined : ('immersiveView.googleStreetViewAccessDenied' | transloco)"
        [type]="
            immersiveViewService.currentImmersiveView() === ImmersiveViewServiceEnum.GOOGLE_STREET_VIEW
                ? ButtonType.PRIMARY
                : ButtonType.SECONDARY
        "
        (onClick)="selectView(ImmersiveViewServiceEnum.GOOGLE_STREET_VIEW)" />
</div>
